export default {
  ru: "RU",
  en: "EN",
};
